Vue.component("create-service-provider", {

    props: ["serviceProviderTypes"],

    data () {
        return {
            form: new AppForm({}),
        };
    },

    methods: {
        createServiceProvider () {

            App.post("/serviceproviders/create", this.form)
            .then(() => {
                this.form = new AppForm({});
                Bus.$emit("service-provider-created");
                window.toastr.success("Service Provider created!");
            })
            .catch(() => {
                window.toastr.error("Service Provider could not be created!");
            });
        },
    }

});
